module.exports = __webpack_public_path__ + "img/chart.d57c70f2.png";